module.exports = __webpack_public_path__ + "static/media/mazaZoleWon_250_500.a423106c.png";